import { useState, useEffect } from "react";
import axios from "axios";
import { AdminAuth } from "../components/admin/AdminAuth";
import { AdminDashboard } from "../components/admin/AdminDashboard";
import { API, getToken, clearToken } from "../lib/admin";

export default function Admin() {
  const [authed, setAuthed] = useState(null); // null=checking, true, false

  useEffect(() => {
    const token = getToken();
    if (!token) {
      setAuthed(false);
      return;
    }
    axios
      .get(`${API}/auth/me`, { headers: { Authorization: `Bearer ${token}` } })
      .then(() => setAuthed(true))
      .catch(() => {
        clearToken();
        setAuthed(false);
      });
  }, []);

  if (authed === null) {
    return <div className="min-h-screen bg-navy" data-testid="admin-loading" />;
  }

  return authed ? (
    <AdminDashboard onLogout={() => setAuthed(false)} />
  ) : (
    <AdminAuth onAuthenticated={() => setAuthed(true)} />
  );
}
